// extracted by mini-css-extract-plugin
export var blurb = "GiftValuePanel-module__blurb___kWuZ7";
export var blurbs = "GiftValuePanel-module__blurbs___yneZI";
export var container = "GiftValuePanel-module__container___TxxKS";
export var give = "GiftValuePanel-module__give___WPFOB";
export var imageAndBlurbs = "GiftValuePanel-module__imageAndBlurbs___kfZ_F";
export var img = "GiftValuePanel-module__img___VlrdW";
export var perfect = "GiftValuePanel-module__perfect___ObsvC";
export var perfectForAllContainer = "GiftValuePanel-module__perfectForAllContainer___H5RSV";